import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";
import { showDialogOverlay, hideDialogOverlay } from "../../../utils/dialogOverlay.js";
import { renderUyeliklerGrid } from "../uyeliklerGrid.js";
import { uiState } from "../../../state/uiState.js";
import { truncateLabel } from "../../../utils/textPresentation.js";

const API = "/api";
let didBind = false;

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function ensureUyeliklerEditDialog() {
	if (document.getElementById("uyeliklerEditDialog")) return;
	document.body.insertAdjacentHTML(
		"beforeend",
		`
<dialog id="uyeliklerEditDialog">
    <form method="dialog" novalidate class="create-dialog-container">
        <div class="create-dialog-header">
            <h4>Üyelik Düzenle</h4>
        </div>
        <div class="create-dialog-content">
            <div class="section">
                <div class="section-1-header"><h5>Kişi Bilgileri</h5></div>
                <div class="section-1-content">
                    <div class="info-card-yeni">
    <div class="info-card-yeni-satir">
        <div class="info-card-yeni-etiket">T.C. Kimlik No</div>
        <div class="info-card-yeni-deger info-card-yeni-deger--mono uyelikler-edit-tc">—</div>
    </div>
    <div class="info-card-yeni-satir">
        <div class="info-card-yeni-etiket">Ad</div>
        <div class="info-card-yeni-deger uyelikler-edit-ad">—</div>
    </div>
    <div class="info-card-yeni-satir">
        <div class="info-card-yeni-etiket">Soyad</div>
        <div class="info-card-yeni-deger uyelikler-edit-soyad">—</div>
    </div>
</div>
                </div>
            </div>
            <div class="section">
                <div class="section-1-header"><h5>Üyelik Bilgileri</h5></div>
                <div class="section-1-content">
                    <div class="column-container uyelikler-email">
                        <label for="edit_uyelikler_email">Email:</label>
                        <input id="edit_uyelikler_email" class="form-input" type="text" name="email" maxlength="100" placeholder="ornek@kurumadi.com" required autocomplete="off" />
                        <span class="info" data-focus="Üyenin email adresini girin." data-invalid="Geçerli bir email adresi giriniz."></span>
                    </div>
                    <div class="column-container uyelikler-yetki">
                        <label for="edit_uyelikler_yetki">Yetki:</label>
                        <select id="edit_uyelikler_yetki" class="form-select" name="yetki_id" required>
                            <option value="" selected>Yetki seçiniz</option>
                        </select>
                        <span class="info" data-focus="Üyenin yetkisini seçin." data-invalid="Yetki seçilmelidir."></span>
                    </div>
                    <div class="column-container uyelikler-durum">
                        <label for="edit_uyelikler_durum">Üyelik Durumu:</label>
                        <select id="edit_uyelikler_durum" class="form-select" name="is_active" required>
                            <option value="1">Aktif</option>
                            <option value="0">Pasif</option>
                        </select>
                        <span class="info" data-focus="Üyeliğin giriş durumunu seçin." data-invalid="Durum seçilmelidir."></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="create-dialog-buttons">
            <button type="button" class="edit-cancel">İptal</button>
            <button type="submit" class="create-save">Kaydet</button>
        </div>
    </form>
</dialog>`,
	);
}

export function initUyeliklerEditDialog() {
	ensureUyeliklerEditDialog();
	const dialog = document.querySelector("#uyeliklerEditDialog");
	if (!dialog || didBind) return;
	didBind = true;

	const form = dialog.querySelector("form");
	const emailEl = dialog.querySelector("#edit_uyelikler_email");

	function syncEmailValidity() {
		const v = emailEl.value.trim();
		if (!v) {
			emailEl.setCustomValidity("");
			return;
		}
		if (!EMAIL_RE.test(v)) emailEl.setCustomValidity("Geçerli bir email adresi giriniz.");
		else emailEl.setCustomValidity("");
	}
	emailEl.addEventListener("input", syncEmailValidity);
	emailEl.addEventListener("blur", syncEmailValidity);

	document.body.addEventListener("click", (e) => {
		if (e.target.closest(".edit-cancel") && dialog.open) dialog.close();
	});

	dialog.addEventListener("close", () => {
		delete dialog.dataset.submitted;
		form?.reset();
		emailEl?.setCustomValidity("");
		dialog.querySelector(".uyelikler-edit-tc").textContent = "—";
		dialog.querySelector(".uyelikler-edit-ad").textContent = "—";
		dialog.querySelector(".uyelikler-edit-soyad").textContent = "—";
	});

	if (form && !form._bound) {
		form._bound = true;
		form.addEventListener("submit", async (e) => {
			e.preventDefault();
			dialog.dataset.submitted = "true";

			if (!form.checkValidity()) {
				showToast("Lütfen tüm zorunlu alanları doldurunuz.", "error");
				form.querySelector(":invalid")?.scrollIntoView({
					behavior: "smooth",
					block: "center",
				});
				return;
			}

			const id = dialog.dataset.id;
			const email = emailEl.value.trim();
			const yetki_id = Number(dialog.querySelector("#edit_uyelikler_yetki").value);
			const is_active = Number(dialog.querySelector("#edit_uyelikler_durum").value);

			showDialogOverlay(dialog);
			await new Promise((r) => setTimeout(r, 350));
			try {
				const res = await fetch(`${API}/uyeler/${encodeURIComponent(id)}`, {
					method: "PUT",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({ email, yetki_id, is_active }),
				});
				const data = await res.json();
				if (!data.ok) {
					showToast(data.error || "Güncelleme sırasında hata oluştu.", "error");
					return;
				}
				showToast("Üyelik başarıyla güncellendi.", "success", false);
				dialog.close();
				const refreshUrl = uiState.uyelikler.lastSearchUrl ?? `${API}/uyeler`;
				renderUyeliklerGrid({
					url: refreshUrl,
					paginationLimit: uiState.uyelikler.paginationLimit,
				});
			} catch (err) {
				console.error("❌ PUT /uyeler hatası:", err);
				showToast("Sunucuya bağlanılamadı.", "error");
			} finally {
				hideDialogOverlay();
			}
		});
	}

	window.openUyeliklerEditDialog = async (id) => {
		const f = dialog.querySelector("form");
		delete dialog.dataset.submitted;
		f?.reset();
		emailEl?.setCustomValidity("");
		dialog.dataset.id = id;

		dialog.showModal();
		showDialogOverlay(dialog, "Yükleniyor...");
		await new Promise((r) => setTimeout(r, 350));
		try {
			const [uyeData, yetkiData] = await Promise.all([
				fetch(`${API}/uyeler/${encodeURIComponent(id)}`).then((r) => r.json()),
				fetch(`${API}/yetkiler`).then((r) => r.json()),
			]);

			dialog.querySelector(".uyelikler-edit-tc").textContent = uyeData.kisi_tc ?? "—";
			dialog.querySelector(".uyelikler-edit-ad").textContent = uyeData.first_name ?? "—";
			dialog.querySelector(".uyelikler-edit-soyad").textContent = uyeData.last_name ?? "—";

			const yetkiSel = dialog.querySelector("#edit_uyelikler_yetki");
			yetkiSel.innerHTML = '<option value="" selected>Yetki seçiniz</option>';
			(yetkiData.items || []).forEach((item) => {
				const fullLabel = String(item.label || item.name || "");
				const opt = document.createElement("option");
				opt.value = item.id;
				opt.textContent = truncateLabel(fullLabel, 32);
				opt.title = fullLabel;
				yetkiSel.appendChild(opt);
			});

			emailEl.value = uyeData.email ?? "";
			yetkiSel.value = String(uyeData.yetki_id ?? "");
			dialog.querySelector("#edit_uyelikler_durum").value = String(uyeData.is_active ?? 1);
		} catch (err) {
			console.error("❌ Üye düzenleme verisi yüklenemedi:", err);
		} finally {
			hideDialogOverlay();
		}
	};
}

function showToast(message, type = "success", inDialog = true) {
	Toastify({
		text: message,
		duration: 3000,
		gravity: "top",
		position: "right",
		stopOnFocus: true,
		selector: inDialog ? document.querySelector("#uyeliklerEditDialog") : document.body,
		style: {
			background: type === "success" ? "#22c55e" : "#ee4447",
			borderRadius: "8px",
			fontSize: "14px",
			fontWeight: "500",
		},
	}).showToast();
}
